import React from "react";
import { Table } from "semantic-ui-react";
import FilaCitas from "./tablaCitas/FilaCitas";

function TablaCitas(props) {
  return (
    <Table selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell content="Creación" />
          <Table.HeaderCell content="Fecha" />
          <Table.HeaderCell content="Descripción" />
          <Table.HeaderCell content="Acciones" />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {props.datos.map(cita => (
          <FilaCitas
            key={cita.id}
            datos={cita}
            handleBorrarItem={props.handleBorrarCita}
            handleEditItem={props.handleEditCita}
            handleCompletarTarea={props.handleCompletarCita}
          />
        ))}
      </Table.Body>
    </Table>
  );
}

export default TablaCitas;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaCita/TablaCitas.jsx